import React from 'react'
import * as classes from './footer.module.scss'
import Iconlink from '../iconlink/iconlink'
import { Link } from 'gatsby'

export default function Footer() {
    return (
        <footer className={classes.Footer}>
            <div className="container">
                <div className="row">
                    <div className={"col-sm-6"}>
                        <h4 className={classes.FooterHeading}>Follow us</h4>
                        <div className={classes.Icons}>
                        <Iconlink url="https://nl.linkedin.com/company/witteveen-bos" icon="linkedin" />
                        <Iconlink url="https://twitter.com/WitteveenBos_VR" icon="twitter" />
                        {/* <a href="#" mailto="pieter-bas.de.visser@witteveenbos.com">Mail</a> */}
                        </div>
                    </div>

                    <div className={"col-sm-6 " + classes.Copyright}>
                        {(new Date().getFullYear())} &copy; Witteveen+Bos N.V. -&nbsp;<Link to={"/disclaimer"}>Disclaimer</Link>
                    </div>
                </div>


            </div>
        </footer>
    )
}